import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  SmartBackButton,
  SmartBlock,
  SmartSpace,
  SmartButton,
} from '../SmartComponent';
//import { useTranslation } from 'react-i18next';

export default function Pick(): JSX.Element {
  //const { t } = useTranslation()
  const history = useHistory();

  const onPageBack = () => {
    //history.goBack();
    history.push('/smart');
  };

  return (
    <SmartBlock>
      <SmartSpace>
        <Link to="/smart/wh-transfer/receive">
          <SmartButton>Receive Transfer</SmartButton>
        </Link>
      </SmartSpace>
      <SmartSpace>
        <SmartBackButton
          onClick={() => onPageBack()}
        />
      </SmartSpace>
    </SmartBlock>
  );
}
